module.exports = __webpack_public_path__ + "static/media/icon-zoom.5495423c.svg";